import { useMemo } from 'react'
import geoListDefinition from '~/packages/geo/list/geoList.definition'
import { SpaceGeoStandardType } from '~/packages/general/variable/spaceTime.types'
import useAction from '~/prix/react/hooks/action'
import useAPI from '~/prix/react/hooks/api'
import { Delimitation } from './useDelimitation'

export function useInitialSpaceLayer() {
  const { context, isLoading: isLoadingAPI } = useAPI()
  const preferredGeneralSettings = context.user?.activeClient?.settings?.general

  const initialGeo = useAction(
    geoListDefinition,
    {
      spaces: [
        {
          delimitationTitle: preferredGeneralSettings?.preferredSpaceDelimitationTitle,
          delimitationType: preferredGeneralSettings?.preferredSpaceDelimitationType,
          childrenType: preferredGeneralSettings?.preferredSpaceDelimitationType,
          delimitationId: preferredGeneralSettings?.preferredSpaceDelimitationId,
        },
      ],
      include: ['geometry'],
      limit: 1,
    },
    [preferredGeneralSettings],
    {
      autoLoad:
        Boolean(
          context.user &&
            preferredGeneralSettings &&
            preferredGeneralSettings?.preferredSpaceDelimitationId != null &&
            preferredGeneralSettings?.preferredSpaceDelimitationType,
        ) && !isLoadingAPI,
      staleWhileRevalidate: true,
    },
  )

  const initialSpaceLayer = useMemo(() => {
    return {
      id: initialGeo.result?.items[0]?.id,
      name: initialGeo.result?.items[0]?.name,
      type: initialGeo.result?.items[0]?.type as SpaceGeoStandardType,
      shape: initialGeo.result?.items[0]?.shape,
    } as Delimitation
  }, [initialGeo.result?.items])

  return { initialSpaceLayer, isLoadingInitialSpace: initialGeo.isLoading }
}
